import React from 'react'

const WeeklyInputView=(props)=>{
    return (
       <>
        <div className="input-field col s6">
        <input type="date" id="WeekDate" onChange={props.handleChange} />
        <label className="active" htmlFor="WeekDate">Week Date</label>
        </div>
        </>
    )
    
}

export default WeeklyInputView
